var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"pano"},on:{"dblclick":_vm.dblclickScene,"click":_vm.clickScene}})])
}
var staticRenderFns = []

export { render, staticRenderFns }